(ns motorsaif.web.pages.verify-code
  (:require
   [clojure.string :as str]
   [motorsaif.web.components :as c]
   [motorsaif.validation :as validation]
   [motorsaif.web.lib.form :as form]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [motorsaif.log :as log]
   [motorsaif.web.svg :as svg]
   [reagent.core :as r]
   [motorsaif.string :refer [format]]
   [motorsaif.frontend-routes :as routes]))

;; I should stay on the page I am, then invoke the modal.
;; No redirections should happen.

(defn- new-user-request [{:keys [all-data]}]
  (let [req {:type :POST
             :url "/api/account/verify-code"
             :params {:data
                      (assoc all-data :context :new-user)}
             :id :verify-code
             :handler
             (fn [{:keys [state] :as res}]
               (log/info [:sign-up res])
               (condp = state
                 :validated
                 (js/window.location.reload)
                 :already-verified
                 (js/window.location.reload)
                 :code-invalid
                 (rf/dispatch [:toast {:type "error"
                                       :message "Code invalid"}])))
             :error-handler (fn [res]
                              (rf/dispatch [:toast {:type "error"
                                                    :message "Backend server error"}]))}]
    (rf/dispatch [:do-ajax req])))

(comment
  (on-submit {:all-data {:email "naomarik@gmail.com"
                         :code "1111"}}))


(defn new-user [email]
  (let [form-key :sign-up
        {:keys [*data *validated-data form-params input radio] :as form-args}
        (form/make-form {:schema validation/verify-code
                          ;; Does not handle valid values
                          ;; :change-watch #(dispatch [:reset-form form-key %])
                          :on-submit {:valid new-user-request
                                      :invalid (fn [error]
                                                 (println "Submit error " error))}
                          :init-data
                          {:email email}})]
    (fn []
      (when-not email
        (rf/dispatch [:common/navigate! :sign-up]))
      [:div.root-wrap
       [:div.logo.sm svg/logo]
       [:div.container.sm
        [:div
         [:h2 "Verification"]
         [:p.subtitle
          [:span "Your code was sent to"]
          [:div.text.med.bold email]
          [:p " Check your email and spam folder."]]
         [:form
          form-params
          [:div.code
           [input {:placeholder "Code"
                   :type :number}
            [:code]]]
          [:p.login
           [:a {:href (routes/path-for :sign-up)}
            [:span "Did not get an email? "]
            [:span.bold
             "Resend Code"]]]
          [:button.btn.primary.full
           {:type "submit"}
           "Verify"]]]]])))

(defn- forgot-password-request [{:keys [all-data]}]
  (let [req {:type :POST
             :url "/api/account/verify-code"
             :params {:data (assoc all-data :context :forgot-password)}
             :id :verify-code
             :handler
             (fn [{:keys [state] :as res}]
               (condp = state
                 :validated
                 (js/window.location.reload)
                 :code-invalid
                 (rf/dispatch [:toast {:type "error"
                                       :message "Code invalid"}])))
             :error-handler (fn [res]
                              (rf/dispatch [:toast {:type "error"
                                                    :message "Backend server error"}]))}]
    (rf/dispatch [:do-ajax req])))

(defn forgot-password [email]
  (let [form-key :forgot-password
        {:keys [*data *validated-data form-params input radio] :as form-args}
        (form/make-form {:schema validation/verify-code
                          :on-submit {:valid forgot-password-request
                                      :invalid (fn [error]
                                                 (println "Submit error " error))}
                          :init-data
                          {:email email}
                          #_{:user/email (str "naomarik" "@gmail.com")
                             :user/handle "Naomarik"
                             :user/password "hello"
                             }})]
    (fn []
      (when-not email
        (rf/dispatch [:common/navigate! :sign-up]))
      [:div.root-wrap
       [:div.logo.sm svg/logo]
       [:div.container.sm
        [:div
         [:h2 "Verification"]
         [:p.subtitle
          [:span "Your code was sent to"]
          [:div.text.med.bold email]]
         [:form
          form-params
          [:div.code
           [input {:placeholder "Code"
                   :label "Code"
                   :type :number}
            [:code]]]
          [input {:placeholder "New password"
                  :label "New Password"
                  :type "password"}
           [:password]]
          [:p.login
           #_[:a {:href (routes/path-for :login)}
              [:span "Did not get an email? "]
              [:span.bold
               "Resend Code"]]]
          [:button.btn.primary.full
           {:type "submit"}
           "Confirm and Login"]]
         ]]])))

(defn verify-success []
  [:div.root-wrap
   [:div.logo.sm svg/logo]
   [:div.container.sm
    [:div
     [:h2 "Winner"]
     [:p.subtitle
      [:span "Code verified"]]

     [:button.btn.primary.full
      {:type "button"
       :on-click #(do
                    (rf/dispatch [:common/navigate! :home]))}
      "Browse Feed"]

     [:hr]

     [:button.btn.secondary.full
      {:type "submit"}
      "New Request"]]]])

;; We ask for username/phone on next step

(defn root []
  (let [{:keys [email context]} @(subscribe [:verification])]
    (if (and context email)
      (condp = context
        :new-user
        [new-user email]
        :forgot-password
        [forgot-password email])
      (rf/dispatch [:common/navigate! :feed]))
    ;; [verify-success]
    ))

(comment
  (rf/dispatch [:verification {:email "asdf@naomarik.com"
                               :context :new-user} ]))
